import { Box } from '@mui/material';
import { FC } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import Authentication from './content/authentication';
import Changelog from './content/changelog';
import ErrorHandling from './content/error-handling';
import Introduction from './content/introduction';
import QuickStart from './content/quick-start';
import RateLimits from './content/rate-limits';
import Support from './content/support';
import Webhooks from './content/webhooks';
import DocsSidebar from './docs-sidebar';

const DocsPage: FC = () => (
  <Box sx={{ display: 'flex' }}>
    <DocsSidebar
      navGroups={[
        {
          title: 'Getting Started',
          items: [
            { label: 'Introduction', path: 'introduction' },
            { label: 'Authentication', path: 'authentication' },
            { label: 'Rate Limits', path: 'rate-limits' }
          ]
        },
        {
          title: 'Guides',
          items: [
            { label: 'Quick Start Guide', path: 'quick-start' },
            { label: 'Webhooks', path: 'webhooks' },
            { label: 'Error Handling', path: 'error-handling' }
          ]
        },
        {
          title: 'Resources',
          items: [
            { label: 'Changelog', path: 'changelog' },
            { label: 'Support', path: 'support' }
          ]
        }
      ]}
    />

    <Box component="main" sx={{ padding: 4 }}>
      <Routes>
        <Route index element={<Navigate to="introduction" replace />} />
        <Route path="introduction" element={<Introduction />} />
        <Route path="authentication" element={<Authentication />} />
        <Route path="rate-limits" element={<RateLimits />} />
        <Route path="quick-start" element={<QuickStart />} />
        <Route path="webhooks" element={<Webhooks />} />
        <Route path="error-handling" element={<ErrorHandling />} />
        <Route path="changelog" element={<Changelog />} />
        <Route path="support" element={<Support />} />
        <Route path="*" element={<Navigate to="introduction" replace />} />
      </Routes>
    </Box>
  </Box>
);

export default DocsPage;
